/*
 * Библиотека Bootstrap. Включает в себя компоненты и иконки.
 * Список доступных иконок доступен по ссылке https://bootstrap-vue.js.org/docs/icons/
 */
import Vue from 'vue';
import { VueConstructor } from 'vue/types/umd';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';


const bootstrapPlugin = {
    install(Vue : VueConstructor<Vue>) {
        Vue.use(BootstrapVue);
        Vue.use(IconsPlugin);
    }
};

/**
 * Плагин для установки набора компонентов Bootstrap
 */
export default bootstrapPlugin;
